// extracted by mini-css-extract-plugin
export default {"spectrumManager":"styles_spectrumManager__+YXWd","content":"styles_content__6SRNf"};